import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AdminRoutes } from '../mia-admin/AdminRouter'
import { PostTryOnRouteGuard } from '../mia-post-tryon/pages/PostTryOnRouteGuard'
import { FullPageLoader } from '../shared/components/FullPageLoader'

const LoginPage = lazy(() => import('../mia-auth/pages/LoginPage'))
const PublicTryOnPage = lazy(() => import('../mia-tryon/pages/PublicTryOnPage'))
const PublicApparelTryOnPage = lazy(() => import('../mia-tryon-apparel/pages/PublicApparelTryOnPage'))
const PublicTryOnSessionPage = lazy(() => import('../mia-tryon/pages/PublicTryOnSessionPage'))
const InternalRenderPage = lazy(() => import('../mia-tryon/pages/InternalRenderPage'))
const ExperienceCompletedPage = lazy(() => import('../mia-post-tryon/pages/ExperienceCompletedPage'))

const legacyRoutes = ['tenants', 'channels', 'secrets', 'users', 'roles', 'catalog', 'agents', 'tokens', 'providers', 'routes', 'sessions', 'whatsapp', 'checkout', 'configurations', 'deleted-resources', 'feature-flags', 'audit', 'security']

export function AppRouter() {
  return <BrowserRouter>
    <Suspense fallback={<FullPageLoader label="Carregando módulo" />}>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/login" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<LoginPage />} />
        {AdminRoutes()}
        <Route path="/tryon/:tenantSlug/apparel" element={<PostTryOnRouteGuard><PublicApparelTryOnPage /></PostTryOnRouteGuard>} />
        <Route path="/tryon/:tenantSlug" element={<PostTryOnRouteGuard><PublicTryOnPage /></PostTryOnRouteGuard>} />
        <Route path="/tryon/:tenantSlug/product/:productId" element={<PostTryOnRouteGuard><PublicTryOnPage /></PostTryOnRouteGuard>} />
        <Route path="/experience-completed" element={<ExperienceCompletedPage />} />
        <Route path="/tryon/session/:sessionToken" element={<PublicTryOnSessionPage />} />
        <Route path="/tryon/render/:renderToken" element={<InternalRenderPage />} />
        {legacyRoutes.map((path) => <Route key={path} path={`/${path}`} element={<Navigate to={`/admin/${path}`} replace />} />)}
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
}
